import React from 'react';
import { capitalize, Stack, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

interface Props {
  departmentsWithStages: {
    flowId: string;
    department: string;
    departmentName: string;
    currentStageId: string;
    currentStageName: string;
  }[];
}

export const DepartmentsCell = ({ departmentsWithStages }: Props) => {
  return (
    <RenderWithCondition
      condition={Boolean(departmentsWithStages.length)}
      fallBack={
        <Typography variant="body2" color="text.secondary">
          No applicable Business Process Flow assigned.
        </Typography>
      }
    >
      <Stack>
        {departmentsWithStages.map(({ flowId, department, currentStageName }) => (
          <Typography variant="body2" key={flowId} sx={{ whiteSpace: 'nowrap' }}>
            {capitalize(department)}: {currentStageName || 'N/A'}
          </Typography>
        ))}
      </Stack>
    </RenderWithCondition>
  );
};
